// extracted by mini-css-extract-plugin
export default {"listContainer":"details_listContainer__xW2J3","desktopGrid":"details_desktopGrid__T+vSw","largeGrid":"details_largeGrid__FLJWd"};